<template>
  <div class="home">
    <h3 v-if="!state.showReceipt">Total payment: {{ transactions.length }}/{{ users.length }}</h3>
    <a href="/admin" v-if="state.showReceipt">Back to admin</a>
    <div class="container" v-if="!state.showReceipt">
      <UserTable :onClickReceipt="onClickReceipt" :users="users"/>
    </div>
    <ReceiptFlow :admin="true" v-if="state.showReceipt"/>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import UserTable from '@/components/UserTable'
import ReceiptFlow from '@/components/ReceiptFlow'

export default {
  components: {
    UserTable,
    ReceiptFlow
  },
  data() {
    return {
      transactions: [],
      users: [],
      blackList: ['jubwarata@gmail.com', 'benwrk@live.com', 'paijung.pt@gmail.com'],
      state: {
        showReceipt: false
      }
    }
  },
  async created() {
    await this.loadTransactions()
    await this.loadUsers()
    this.mapTransactionWithUsers()
  },
  methods: {
    async loadTransactions() {
      const response = await axios.get('/transactions')
      this.transactions = response.data
      this.blackList.forEach(email => {
        const index = this.transactions.findIndex(trans => trans.email.toLowerCase() === email.toLowerCase())
        if (index > -1) {
          this.transactions.splice(index, 1)
          console.log('Cut trnasactions', email)
        }
      })
    },
    async loadUsers() {
      const response = await axios.get('/users')
      this.users = response.data
      this.blackList.forEach(email => {
        const index = this.users.findIndex(user => user.Email.toLowerCase() === email.toLowerCase())
        if (index > -1) {
          this.users.splice(index, 1)
        }
      })
    },
    mapTransactionWithUsers() {
      this.transactions.forEach(trans => {
        const index = this.users.findIndex(user => user.Email.toLowerCase() === trans.email.toLowerCase())
        if (index > -1) {
          this.users[index].status = 'paid'
          this.users[index].paymentDate = this.formatDate(new Date(trans.timestamp))
          this.users[index].paypal = trans.paypal
          this.users[index].timestamp = trans.timestamp
          this.users[index].orderId = trans.orderId
        }
      })
    },
    formatDate(date) {
      var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
      ]

      const day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      const hour = date.getHours()
      const minutes = date.getMinutes()
      // ${hour}:${minutes}
      return `${day}/${monthIndex}/${year}`;
    },
    async onClickReceipt(user) {
      console.log(user)
      this.$store.dispatch('updateAdmin', true)
      this.$store.dispatch('updatePayment', user)
      this.$store.dispatch('updateEmail', user.Email)
      const receipt = await this.checkReciept(user.Email)
      console.log('click check', receipt)
      if(receipt) {
        // SHOW
      } else {
        this.$store.dispatch('updateName', `${user['First name']} ${user['Last name (family name)']}`)  
        this.$store.dispatch('updateTel', user['Telephone'])
      }
      this.state.showReceipt = true
    },
    async checkReciept(email) {
      try {
        const response = await axios.post('/checkreceipt', { email })
        if (Object.keys(response.data).length > 0) {
          this.state.editable = false
          this.$store.dispatch('updateName', response.data.name)
          this.$store.dispatch('updateCompany', response.data.company)
          this.$store.dispatch('updateAddress', response.data.address)
          this.$store.dispatch('updateTel', response.data.tel)
          this.$store.dispatch('updateReceipt', response.data)
          return true
        }
      } catch (error) {
        return false
      }
      return false
    }
  },
}
</script>
